import React from 'react'

const RightArrow = ({fillColor = 'black', size = '40'}) => {
    return (
        <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M21.9351 28.8849C21.4496 28.3959 21.4496 27.6031 21.9351 27.1141L27.5053 21.5039L9.99324 21.5039C9.30662 21.5039 8.75 20.9432 8.75 20.2517C8.75 19.5601 9.30662 18.9995 9.99324 18.9995L27.5053 18.9995L21.9351 13.3893C21.4496 12.9003 21.4496 12.1074 21.9351 11.6184C22.4206 11.1294 23.2078 11.1294 23.6933 11.6184L31.3859 19.3663C31.619 19.6011 31.75 19.9196 31.75 20.2517C31.75 20.5838 31.619 20.9023 31.3859 21.1371L23.6933 28.8849C23.2078 29.3739 22.4206 29.3739 21.9351 28.8849Z" fill={fillColor}/>
        </svg>
    )
}

export default RightArrow